import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Nav.css';

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = isOpen ? 'auto' : 'hidden';
  };

  const closeMenu = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <button 
        className={`hamburger ${isOpen ? 'open' : ''}`} 
        onClick={toggleMenu}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav className={`nav-overlay ${isOpen ? 'open' : ''}`}>
        <div className="nav-content">
          <div className="nav-links">
            <Link to="/contact" onClick={closeMenu}>Contact Form</Link>
            <Link to="/residential" onClick={closeMenu}>Residential</Link>
            <Link to="/commercial" onClick={closeMenu}>Commercial</Link>
            <Link to="/checklist" onClick={closeMenu}>Checklist</Link>
            <Link to="/careers" onClick={closeMenu}>Careers</Link>
            <Link to="/gallery" onClick={closeMenu}>Gallery</Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Nav; 